/* eslint-disable @typescript-eslint/naming-convention */
export enum Locale {
  de_DE = 'de-DE',
  en_US = 'en-US',
  es_ES = 'es-ES',
  fr_FR = 'fr-FR',
  it_IT = 'it-IT',
  nl_NL = 'nl-NL',
  pt_PT = 'pt-PT',
}

export enum Lang {
  DE = 'de',
  EN = 'en',
  ES = 'es',
  FR = 'fr',
  IT = 'it',
  NL = 'nl',
  PT = 'pt',
}

export function langFromString(langStr: string): Lang | undefined {
  return Object.entries(Lang).find(entry => {
    if (entry[0].toLocaleLowerCase() === langStr.toLocaleLowerCase()) {
      return true
    }
    return undefined
  })?.[1]
}
/* eslint-enable */

export const LANG_TO_LOCALE: Record<Lang, Locale> = {
  [Lang.EN]: Locale.en_US,
  [Lang.FR]: Locale.fr_FR,
  [Lang.DE]: Locale.en_US,
  [Lang.ES]: Locale.en_US,
  [Lang.IT]: Locale.en_US,
  [Lang.NL]: Locale.en_US,
  [Lang.PT]: Locale.en_US,
}

export const LOCALE_TO_LANG = {
  [Locale.de_DE]: Lang.DE,
  [Locale.en_US]: Lang.EN,
  [Locale.es_ES]: Lang.ES,
  [Locale.fr_FR]: Lang.FR,
  [Locale.it_IT]: Lang.IT,
  [Locale.nl_NL]: Lang.NL,
  [Locale.pt_PT]: Lang.PT,
}

export const LOCALES = {
  [Locale.en_US]: {
    code: Locale.en_US,
    countryCode: 'US',
    icon: '🇺🇸',
    locale: Lang.EN,
    name: 'English',
  },
  [Locale.fr_FR]: {
    code: Locale.fr_FR,
    countryCode: 'FR',
    icon: '🇫🇷',
    locale: Lang.FR,
    name: 'Français',
  },
  [Locale.de_DE]: {
    code: Locale.de_DE,
    countryCode: 'DE',
    icon: '🇩🇪',
    locale: Lang.DE,
    name: 'Deutsch',
  },
  [Locale.es_ES]: {
    code: Locale.es_ES,
    countryCode: 'ES',
    icon: '🇪🇸',
    locale: Lang.ES,
    name: 'Español',
  },
  [Locale.it_IT]: {
    code: Locale.it_IT,
    countryCode: 'IT',
    icon: '🇮🇹',
    locale: Lang.IT,
    name: 'Italiano',
  },
  [Locale.nl_NL]: {
    code: Locale.nl_NL,
    countryCode: 'NL',
    icon: '🇳🇱',
    locale: Lang.NL,
    name: 'Nederlands',
  },
  [Locale.pt_PT]: {
    code: Locale.pt_PT,
    countryCode: 'PT',
    icon: '🇵🇹',
    locale: Lang.PT,
    name: 'Português',
  },
}

export const DATE_STRING_FORMAT = 'YYYY-MM-DD'
export const FR_DATE_STRING_FORMAT = 'DD-MM-YYYY'
export const DEFAULT_LOCALE = Locale.fr_FR
